export const LINK_TYPE_QR_CODE = 'qrCode' as const;
export const QR_CODE = 'QR_CODE';
